import React from "react";
import { Link } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { getScheduleMainGridUnits } from "data/Querys";
import { dateFormatNoTz, getDateTimeFormat, groupByDateNoTz } from "helpers/utils";
import { dateFormat } from "helpers/utils";
import { useViewport } from 'components/general/useViewPort';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import NotAvailable from "components/common/NotAvailable";
import Loader from 'components/general/Loader';
import MirsTable from "components/general/table/Table";
import Label, { useLabels } from "components/general/Label";
import Discipline from "components/presentation/Discipline";
import { useGetURL, useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Sprites from "styles/images/SpriteIcons.svg";
import { useSelector } from "react-redux";
import { useGetDisciplines } from "helpers/commonCodes";
import SelectorTimeZone from "components/common/selectors/selector-timezone";
import SvgMirs from "components/presentation/SvgMirs";


function hasParentWithMatchingSelector(selector) {
  let arr = [...document.querySelectorAll(selector)]
  return arr.length > 0 ? true : false
}


function ScheduleGrid() {

  let params = useUrlFriendlyToParameters();
  //Copy object in order to change 
  let paramsURL = { ...params }
  //Change object if make changes over params make changes in componets related   (Change URL object)


  const { data, isError, isLoading } = useQuery(//useObtainData(
    {
      queryKey: ['scheduleMainGrid', paramsURL['mirs_competition'], paramsURL['mirs_language']],
      queryFn: getScheduleMainGridUnits,
      refetchInterval: 60000,
    });

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }
  if (!data?.competition_schedule) { return <NotAvailable /> }
  return (<Grid data={data} paramsURL={paramsURL} />)
}

export default ScheduleGrid;


const Grid = ({ data, paramsURL }) => {
  const fLabel = useLabels();
  const { breakPoint } = useViewport();
  const getURL = useGetURL()
  const dataDisciplines = useGetDisciplines(paramsURL);

  let allDisciplines = ['CER'];
  const localtime = useSelector((state) => state.appGlobal.localtime)//only used force refresh page when change selection 


  //const sports = data?.filter(item => item?.isSport && item?.scheduled)
  //sortDataByField(sports, 'description', true, TYPE_DATA.STRING)
  //sports?.map((item, index) => {}

  dataDisciplines?.disciplines?.sort((a, b) => a.description.localeCompare(b.description)).forEach((item, index) => {
    dataDisciplines.manualSortOrder = index;
    if (item.code === "CER") { data.manualSortOrder = -1 }
  });

  dataDisciplines?.disciplines?.sort((a, b) => a.manualSortOrder - b.manualSortOrder);

  dataDisciplines && dataDisciplines?.disciplines.filter(item => item?.isSport && item?.scheduled)?.forEach((item, index) => {
    allDisciplines.push(item.code);
  });

  let allDates = [];

  var result = [];
  data?.competition_schedule.forEach(res => {
    if (res?.discipline) {
      //let sch = result.find(item => dateFormat(item.date) === dateFormat(res.date) && item.discipline.code === res.discipline.code) //Expend a lot of time
      let newDate = dateFormat(res.dateTime)
      let sch = result.find(item => item.date === newDate && item.discipline.code === res.discipline.code)
      //Check exist 
      if (!sch) {
        let csObject = {
          //"datecheck": res.dateTime,
          "discipline": res.discipline,
          "date": newDate,
          "eventCount": 1,
          "medalEventCount": res.medalEventCount > 0 ? 1 : 0,
          "liveEventCount": res.liveEventCount > 0 ? 1 : 0,
          "events": res.medalEventCount > 0 ? [res.event] : []
        }
        result.push(csObject)
      } else {
        sch.eventCount = sch?.eventCount + 1
        sch.medalEventCount = res?.medalEventCount > 0 ? sch?.medalEventCount + 1 : sch?.medalEventCount
        sch.liveEventCount = res?.liveEventCount > 0 ? sch?.liveEventCount + 1 : sch?.liveEventCount
        if (sch?.medalEventCount > 0 && !sch?.events?.find(item => item?.code === res?.event?.code)) {
          sch.events = [...sch?.events, res?.event]
        }
      }
    }
  })



  let dates = groupByDateNoTz(result, 'date');


  for (const [key] of Object.entries(dates)) {
    allDates.push({ key })
  }

  let allDatesSort = allDates.sort((a, b) => new Date(a.key) - new Date(b.key));
  let dataTable;
  let rowDiscipline = [];
  allDisciplines?.forEach((discipline, indexDis) => {
    let rowItem = {};
    rowItem.discipline = discipline;
    let allDays = [];
    allDatesSort?.forEach((day, indexDay) => {

      let date = dates[day.key]
      let scheduleData = date.find(item => item?.discipline?.code === discipline)
      let disciplineData = dataDisciplines?.disciplines.find(item => item?.code === discipline)
      let dataItem = {};
      dataItem.discipline = discipline;
      dataItem.description = disciplineData?.description;
      dataItem.disciplineOrder = indexDis;
      dataItem.date = day.key;
      dataItem.eventCount = scheduleData ? scheduleData?.eventCount : 0;
      dataItem.medalEventCount = scheduleData ? scheduleData?.medalEventCount : 0;
      dataItem.events = scheduleData?.events?.sort((a, b) => a?.order - b?.order);
      allDays.push(dataItem);
      //rowItem = rowItem + dataItem + ","
      //rowDiscipline.push(rowItem)
    })
    rowItem.data = [...allDays]
    rowDiscipline.push(rowItem);
  })
  dataTable = [...rowDiscipline];

  //{dataTable.map(item => <div>{item[0]?.description}</div>)}sss
  let cols = [];
  allDatesSort?.forEach((day, indexDay) => {
    cols.push(
      {
        id: 'fecha' + (indexDay + 1),
        Header: () => {
          paramsURL["mirs_date"] = day.key
          paramsURL["mirs_discipline"] = ''
          const url = getURL(paramsURL, 'schedule');
          return (
            <>
              <Link to={url}>
                <div>{dateFormatNoTz(day.key, 'DD')}</div>
                <div className="schedule-grid-head-day-week">{dateFormatNoTz(day.key, 'ddd')}</div>
              </Link>
            </>
          )
        },
        accessor: (props) => {
          let dayData = props.data.find(item => item.date === day.key)
          let evetUnitDay = dayData?.eventCount;
          let medalsDay = dayData?.medalEventCount;
          let discipline = dayData?.discipline
          let disciplineDes = dayData?.description
          let eventsToMedal = dayData?.events?.map((event, index) => (<div key={day.key + '-' + discipline + '-' + index}>{event?.description}</div>))
          let outDay;
          let eventDes = dayData?.events?.map((event, index) => (event?.description))
          let date = day.key;
          paramsURL["mirs_discipline"] = discipline
          paramsURL["mirs_date"] = date //pasamos a la URL la nueva fecha del JSON 

          const url = props.discipline !== 'CER' ? getURL(paramsURL, 'schedule') : '';
          const isCeremony = props.discipline === 'CER';
          const formatDateTime = getDateTimeFormat('DayName-DayNum-MonthShort');
          const popover = (
            <Popover id={`mirs-popover-schedule-grid-${day.key + '-' + discipline}`}>
              <Popover.Header as="div">
                <div className={`popover-discipline`}><Discipline code={props.discipline} description={disciplineDes} /></div>
                <div className="popover-date">{dateFormatNoTz(date, formatDateTime)}</div></Popover.Header>
              <Popover.Body>
                {eventsToMedal}
              </Popover.Body>
            </Popover>

          );
          if (isCeremony && evetUnitDay > 0) {
            outDay = <div>
              <div className="sch-ceremony-day">
                <svg role="img" focusable="false" className='mirsIcon ceremony-icon' ><title><Label data={'LabelCerDay'} /></title><use xlinkHref={`${Sprites}#torch1`} /></svg>
              </div>
            </div>
          } else if (medalsDay > 0) {
            outDay = <Link to={url} aria-label={`${disciplineDes + " " + day.key + " " + eventDes}`}>
              <OverlayTrigger trigger={["hover", "hover"]} placement="auto" overlay={popover}>
                <svg role="img" className="mirsIcon medal-icon" data-ocs-label="LabelMedal">
                  <title>{fLabel("Medal")}</title>
                  <use xlinkHref={`${Sprites}#medal`} />
                </svg>
              </OverlayTrigger>
            </Link>
          } else if (evetUnitDay > 0) {
            outDay = <Link to={url} aria-label={disciplineDes + " " + day.key}><SvgMirs className='mirsIcon day-icon' code='circle' title={"LabelDayWithoutMedals"} /></Link>
          }
          return (
            <>
              {outDay}
            </>
          )
        },
        disableSortBy: true,
        className: 'schedule-grid-body-day',
        isVisible: false,
        columnIndex: indexDay + 1,
        headerClassName: 'schedule-grid-head-day'
      },
    )
  })

  let _columns = React.useMemo(
    () => [
      {
        id: 'Rank',
        Header: "Order",
        headerClassName: 'd-none',
        className: 'd-none',
        accessor: (props) => {
          let order = props.data.find(item => item.discipline === props.discipline)?.disciplineOrder;
          return (
            order
          )
        },
      },
      {
        Header: <Label data='LabelDiscipline' />,
        accessor: (props) => {
          let discipline = props.data.find(item => item.discipline === props.discipline)?.description;
          paramsURL["mirs_discipline"] = props.discipline
          paramsURL["mirs_date"] = "";
          const isCeremony = props.discipline !== 'CER';
          const url = isCeremony ? getURL(paramsURL, 'schedule') : '';
          return (<>
            {isCeremony ? <Link to={url} ><Discipline code={props.discipline} description={discipline} /></Link> : <Discipline code={props.discipline} description={discipline} />}
          </>)
        },
        disableSortBy: true,
        className: 'schedule-grid-body-discipline fw-bold',
        headerClassName: 'schedule-grid-head-discipline',
        id: 'discipline'
      }, ...cols], [breakPoint, localtime]
  )

  let countAll = '';
  let totAll = 0;
  let columsAll = 0;
  let number

  if (breakPoint === "sm" || breakPoint === "xs") {
    number = 3
  } else if (breakPoint === "xxl") {
    number = allDatesSort.length
  } else {
    const swInfo = hasParentWithMatchingSelector('.block-web-results');
    number = swInfo ? allDatesSort.length : 10;
  }


  for (var i = Number(number); i < allDatesSort.length; i = i + Number(number)) {
    countAll = countAll + number + ','
    totAll = i;
  }

  if (countAll === '') {
    columsAll = number + ",0"
  } else {
    columsAll = (countAll + (allDatesSort.length - totAll))
  }

  let nCols = columsAll;
  return (
    <>
      <div className="schedule-grid-bgcolor">
        <div className="d-flex justify-content-end my-2">
          <SelectorTimeZone />
        </div>
        <MirsTable
          className='schedule-grid-wrapper'
          data={dataTable}
          columns={_columns}
          theadClassName='schedule-grid-head'
          tbodyClassName='schedule-grid-body'
          colsExtendedVisible={nCols}
          showNavExtendedData={Number(number) < allDatesSort.length}
          colIndex={1}
          id={`mirs-table-schedule-grid`} />
      </div>
    </>
  );
}

